import $ from 'jquery'

const button = $('.seo-expand')

const defaultHeight = 60
const text = $('.faq-category__seo .faq-category__seo-content')
if (text.length) {
  const textHeight = text[0].scrollHeight
  text.css({ 'max-height': defaultHeight, overflow: 'hidden' })

  if (textHeight <= 100) {
    button.hide()
  }

  button.on('click', function () {
    let newHeight = 0
    if (button.hasClass('active')) {
      newHeight = defaultHeight
      button.removeClass('active')
    } else {
      newHeight = textHeight
      button.addClass('active')
    }
    text.animate(
      {
        'max-height': newHeight,
      },
      250
    )
  })
}
